import { Injectable }    from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';


@Injectable()
export class AuthService {

  private headers = new Headers({'Content-Type': 'application/json'});
  private url = environment.apiUrl;
  public auth: Auth = new Auth;

  constructor(private http: Http) { }

  login(credentials: Credentials): Promise<Auth> {
    return this.http
      .post(this.url+'/login', {email: credentials.email, password: credentials.password})
      .toPromise()
      .then(res => {
        Object.assign(this.auth, res.json().user);
        if (credentials.remember) {
          sessionStorage.removeItem('auth');
          localStorage.setItem('auth', JSON.stringify(this.auth));
        } else {
          localStorage.removeItem('auth');
          sessionStorage.setItem('auth', JSON.stringify(this.auth));
        }
        return this.auth;
      })
      .catch(this.handleError);
  }

  register(form: RegisterForm): Promise<any> {
    return this.http
      .post(this.url+'/register', {firstname: form.name, lastname: form.lastName, email: form.email, password: form.password, agree: form.agree})
      .toPromise()
      .then(res => {
        return true;
      })
      .catch(this.handleError);
  }

  confirm(form: ConfirmForm): Promise<any> {
    return this.http
      .post(this.url+'/confirm/' + form.hash, {})
      .toPromise()
      .then(res => {
        return true;
      })
      .catch(this.handleError);
  }

  getProfile(): Promise<any> {
    return this.http
      .get(this.url+'/me')
      .toPromise()
      .then(res => res.json().user)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  public getAuth(): Auth{
    var auth = new Auth;
    var stored = sessionStorage.getItem('auth') ? sessionStorage.getItem('auth') : localStorage.getItem('auth');
    if (stored) {
      Object.assign(auth, JSON.parse(stored));
      this.auth = auth;
    }
    return this.auth;
  }

  public logout(): Promise<boolean> {
    var headers = new Headers({'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.auth.token});
    return this.http
      .post(this.url+'/logout', {}, {headers: headers})
      .toPromise()
      .then(res => {
        this.auth = new Auth;
        sessionStorage.removeItem('auth');
        localStorage.removeItem('auth');
        return true;
      }, fail => {
        this.auth = new Auth;
        sessionStorage.removeItem('auth');
        localStorage.removeItem('auth');
        return false;
      })
      .catch(this.handleError);
  }

  public recover(form: ForgotForm): Promise<any> {
    return this.http
      .post(this.url+'/recover', {email: form.email}, {})
      .toPromise()
      .then(res => {
        return true;
      })
      .catch(this.handleError);
  }

  public reset(form: ResetForm): Promise<any> {
    return this.http
      .post(this.url+'/reset/' + form.hash, {password: form.password}, {})
      .toPromise()
      .then(res => {
        return true;
      })
      .catch(this.handleError);
  }
}


export class Auth {
  private id: number
  private admin: boolean
  private manager: boolean
  private maintainer: boolean
  private status: number
  public firstName: string
  public lastName: string
  public email: string
  public token: string
  public firstLogin: boolean = false;

  public isAuthorized() {
    return this.id > 0;
  }

  public isAdmin() {
    return this.admin === true;
  }

  public isManager() {
    return this.manager === true;
  }

  public isMaintainer() {
    return this.maintainer === true;
  }

  public isFirstLogin() {
    return this.firstLogin === true;
  }

  public isBanned() {
    return this.status == 3;
  }
}

class FormError {
  public field: string
  public type: string
}

export class FormErrors {
  public list: Array<FormError> = []

  public has(fieldName: string, type: string): boolean {
    var hasError = false;
    fieldName = fieldName.toLowerCase();
    this.list.forEach(err => {
      if (err.field.toLowerCase() == fieldName) {
        if (type) {
          hasError = err.type == type;
        } else {
          hasError =  true;
        }
      }
    });
    return hasError;
  }

  public add(err: FormError): void {
    if (!this.has(err.field, err.type)) {
      this.list.push(err);
    }
  }

  public clear(): void {
    this.list = [];
  }

  public isEmpty(): boolean {
    return this.list.length == 0;
  }

  public remove(fieldName: string, type: string): boolean {
    var hasError = false;
    var newList: Array<FormError> = [];
      this.list.forEach((err, i) => {
      if (err.field.toLowerCase() == fieldName) {
        if (type) {
          hasError = err.type == type;
          if (err.type != type) {
            newList.push(err);
          }
        } else {
          hasError = true;
        }
      } else {
        newList.push(err);
      }
    });
    this.list = newList;
    return hasError;
  }
}




export class Credentials {
  public email: string
  public password: string
  public remember: boolean
}

export class RegisterForm {
  public name: string
  public lastName: string
  public email: string
  public password: string
  public agree: boolean
}

export class ConfirmForm {
  public hash: string
}

export class ForgotForm {
  public email: string
}

export class ResetForm {
  public hash: string
  public password: string
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/login/auth.service.ts